var _circle, _circle2, _rect, _circle3, _circle4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMemLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 426,
    cy: 225,
    r: 111,
    fill: "url(#paint0_radial_113_142)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 426,
    cy: 225,
    r: 111,
    fill: "url(#paint1_radial_113_142)",
    fillOpacity: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 341.016,
    width: 229.106,
    height: 67.0186,
    rx: 33.5093,
    transform: "rotate(-30 175 341.016)",
    fill: "url(#paint2_linear_113_142)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 374,
    r: 111,
    fill: "url(#paint3_radial_113_142)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 374,
    r: 111,
    fill: "url(#paint4_radial_113_142)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_113_142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(389 168) rotate(77.5796) scale(172.026)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#595959"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_113_142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(393 174) rotate(78.4862) scale(165.327)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140472,
    stopColor: "#FD8BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827649
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_113_142",
    x1: 289.553,
    y1: 341.016,
    x2: 289.553,
    y2: 408.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A377A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270265,
    stopColor: "#BC94BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362636"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_113_142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139 317) rotate(77.5796) scale(172.026)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#595959"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_113_142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(142 323) rotate(78.4862) scale(165.327)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140472,
    stopColor: "#FD8BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827649
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemLogo);
export default __webpack_public_path__ + "static/media/mem-logo.7e2b59801cae69976a90e9798417d30a.svg";
export { ForwardRef as ReactComponent };